import applied from './box/applied';
import reception from './box/reception';
import reference from './box/reference';

const box = [
  {
    path: '/approval/box/applied',
    component: () => import('@/page/approval/box/Applied.vue'),
    redirect: '/approval/box/applied/vacation',
    children: [...applied],
    meta: {
      name: '신청함',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/approval/box/reception',
    component: () => import('@/page/approval/box/Reception.vue'),
    redirect: '/approval/box/reception/vacation',
    children: [...reception],
    meta: {
      name: '수신함',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/approval/box/reference',
    component: () => import('@/page/approval/box/Reference.vue'),
    redirect: '/approval/box/reference/mealcost',
    children: [...reference],
    meta: {
      name: '참조함',
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/approval/box/all/mealcost',
    name: 'mealcostAll',
    component: () => import('@/page/approval/box/reception/MealCostReceptionAll.vue'),
    meta: {
      name: '식대비 일괄 결재 목록',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/box/all/admit',
    name: 'admitAll',
    component: () => import('@/page/approval/box/reception/AdmitReceptionAll.vue'),
    meta: {
      name: '인정휴가 지급 일괄 결재 목록',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
];

export default box;
